export default __webpack_public_path__ + "static/media/userCardShortcut.48e42287.png";